import { ConditionalDefinitions } from '../form-block/conditionals/contracts';
import { ProvidesSubQuestion, QuestionDisplayType } from '../question-block/contracts';

export const BUSINESS_NAME_FIELD = 'businessName';
export const BUSINESS_ADDRESS_FIELD = 'businessAddress';
export const BUSINESS_ROLE_FIELD = 'businessRole';

export type QuestionFieldMetadata = {
	required?: boolean;
	hideLabel?: boolean;
	orientation?: 'horizontal' | 'vertical';
	displayType?: QuestionDisplayType;
	selectAll?: boolean;
	mode?: 'google' | 'postcode';
	addressTypeId?: number;
};
export type EditFieldsMetadataValue = {
	componentName: string;
	meta: QuestionFieldMetadata;
	label: string;
	labelOverride?: string;
	type?: string; //type does nothing but need it to play nice with the businessfields (customfields)
	placeholder?: string;
};
export type EditFieldsMetadata = Record<string, EditFieldsMetadataValue>;
export type SelectOption = {
	label: string;
	id: string;
	colour?: string;
	labelOverride?: string;
	hide?: boolean;
};
export type BusinessFieldsMetadataValue = {
	label: string;
	id: string;
	type: string;
	isMulti?: boolean;
	labelOverride?: string;
	meta?: QuestionFieldMetadata;
	options?: SelectOption[];
	singleSelect?: boolean;
	allowCreate?: boolean;
	types?: string[];
	fullName?: boolean;
	categories?: string[];
	fieldMatches?: { propertyName: string; value: string }[];
};

export type BusinessFieldsMetadata = Record<string, BusinessFieldsMetadataValue>;
export type CreatePersonBlockMetadata = {
	businessSection?: boolean;
	fieldOrder?: string[];
	editFields?: EditFieldsMetadata;
	businessFields?: BusinessFieldsMetadata;
	isRsvp?: boolean;
	allowMulti?: boolean;
	maximum?: number;
	setPrimaryOrg?: boolean;
	provides?: Record<string, ProvidesSubQuestion>;
	conditionalDefinitions?: ConditionalDefinitions;
	behaviour?: CreatPersonBlockRenderBehaviour;
};

export type CreatPersonBlockRenderBehaviour = 'always-show' | 'hide-preselected' | 'show-with-reset';
